import type { PropsWithChildren } from 'react';
import type React from 'react';

import { useLoadQueue } from './useLoadQueue';

export const ShortUrlsCacheQueueProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	useLoadQueue();

	return <>{children}</>;
};
